import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import { isDefined, functor } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class DonchianChannelTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, displayFormat, yAccessor, options, textFill, labelFill } =
      this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);

    let top, middle, bottom;
    top = middle = bottom = "n/a";

    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      top = displayFormat(item.top);
      middle = displayFormat(item.middle);
      bottom = displayFormat(item.bottom);
    }

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const { highPeriod, lowPeriod } = options;
    const tooltipLabel = `Donchian(${highPeriod}, ${lowPeriod}): `;
    const tooltipValue = `${top}, ${middle}, ${bottom}`;
    return (
      <g
        transform={`translate(${x}, ${y})`}
        className={this.props.className}
        onClick={onClick}
        data-evo-id="tooltip-donchian-channel"
      >
        <ToolTipText
          x={0}
          y={0}
          fontFamily={this.props.fontFamily}
          fontSize={this.props.fontSize}
        >
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{tooltipValue}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

DonchianChannelTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.shape({
    highPeriod: PropTypes.number.isRequired,
    lowPeriod: PropTypes.number.isRequired,
  }).isRequired,
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
};

DonchianChannelTooltip.defaultProps = {
  className: "react-stockcharts-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 0],
};

export default DonchianChannelTooltip;
